import { List as ImmutableList } from 'immutable';
import { getChannelId } from './channelInstanceGetters';
export const getChannelInstancesForChannelId = (instances, genericChannelId) => {
  if (!instances || !genericChannelId) {
    return ImmutableList();
  }
  return instances.filter(instance => getChannelId(instance) === genericChannelId);
};